import type { HydraErrorType } from '@/lib/services/Hydra/_hydraError'
import type { HydraGetShipToOption } from '@/lib/services/Hydra/shipToOptions/hydraGetShipToOptions'
import { hydraGetShipToOptions } from '@/lib/services/Hydra/shipToOptions/hydraGetShipToOptions'
import { sortShipToOptions } from '@/lib/utils/shared/sortByDefaultAddress'
import useGlobalStore from '@/store/useGlobalStore'
import { useEffect, useState } from 'react'

export const useGetShippingAddresses = () => {
  const {
    user: { customer, token },
    setLoaders,
  } = useGlobalStore()

  const [shipToOptions, setShipToOptions] = useState<
    HydraGetShipToOption[] | null
  >(null)

  const [isLoadingShipToOptions, setIsLoadingShipToOptions] = useState(false)
  const [error, setError] = useState<HydraErrorType | null>(null)

  const handleLoadingState = (loading: boolean) => {
    setIsLoadingShipToOptions(loading)
    setLoaders({
      isLoadingSavedAddresses: loading,
    })
  }

  const getShipToOptions = async ({
    href,
    hydraToken,
  }: {
    href: string
    hydraToken: string
  }) => {
    handleLoadingState(true)
    setError(null)

    const shipToOptionsResult = await hydraGetShipToOptions({
      customerUrl: href,
      hydraToken,
    })

    handleLoadingState(false)

    if (shipToOptionsResult?.error) {
      setError(shipToOptionsResult)
      return
    }

    if (!shipToOptionsResult?.shipToOptions) {
      setShipToOptions([])
      return
    }

    setShipToOptions(sortShipToOptions(shipToOptionsResult.shipToOptions))
  }
  const fetchData = async () => {
    if (!customer?.href || !token) return
    await getShipToOptions({ href: customer.href, hydraToken: token })
  }
  useEffect(() => {
    ;(async () => {
      await fetchData()
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customer?.href, token])

  return {
    shipToOptions,
    isLoadingShipToOptions,
    getShipToOptions,
    error,
  }
}
